export const TARGET_APPLIED_ON_OPTIONS = [
  { value: "INDIVIDUAL_MODEL", label: "Individual Model" },
  { value: "TOTAL_HANDSET", label: "Total Handset" },
  { value: "TOTAL_VALUE_OF_DP", label: "Total Value of DP" },
  { value: "TOTAL_HANDSET_TARGET_FROM_RETAILER", label: "Total Handset Target from Retailer" },
  { value: "TOTAL_VALUE_OF_DP_TARGET_FROM_RETAILER", label: "Total Value of DP Target from Retailer" },
];

export const SCHEME_STATUS_OPTIONS = [
  { value: "IN_REVIEW", label: "In Review" },
  { value: "DRAFT", label: "Draft" },
  { value: "ACTIVE", label: "Active" },
];

export const PAYOUT_CRITERIA_OPTIONS = [
  { value: "VALUE_RANGE", label: "Value Range" },
  { value: "PERCENTAGE_PAY", label: "Percentage Pay" },
  { value: "PER_UNIT", label: "Per Unit" },
  { value: "GIFT_REWARD_TRIP", label: "Gift/Reward/Trip" },
];

export const PAYOUT_SELL_TYPE_OPTIONS = [
  { value: "SELL_IN", label: "Sell In" },
  { value: "SELL_OUT", label: "Sell Out" },
  { value: "SELL_IN_AND_SELL_OUT", label: "Sell In and Sell Out" },
  { value: "ACTIVATION", label: "Activation" },
];

export const TARGET_ACHIEVEMENT_OPTIONS = [
  { value: "SELL_IN", label: "Sell In" },
  { value: "SELL_OUT", label: "Sell Out" },
  { value: "SELL_IN_AND_SELL_OUT", label: "Sell In and Sell Out" },
  { value: "ACTIVATION", label: "Activation" },
];

export const getInitialPayload = (periodFrom, periodTo) => ({
  name: "",
  brandId: null,
  imageUrl: "",
  description: "",
  termsAndConditions: "",
  periodFrom,
  periodTo,
  isActive: true,
  status: "DRAFT",
  isDeleted: null,
  isNew: null,
  isExpiring: null,
  groupIds: [],
  groups: [],
  productsDTO: [],
  products: [],
  schemeConfigration: {
    targetAppliedOn: "INDIVIDUAL_MODEL",
    payoutSelectionHelpText: "",
    payoutCriteriaType: "VALUE_RANGE",
    payoutCriteriaTypeGift: "",
    payoutCriteriaTypePerUnitPoints: 0,
    payoutSellType: "SELL_IN",
    schemeConfigName: "",
    targetAchievementType: "SELL_IN",
    periodFrom,
    periodTo,
  },
});

export const getInitialSlabForm = (periodFrom, periodTo) => ({
  isDefaultSlab: true,
  description: "",
  amount: "",
  remark: "",
  gift: "",
  rangeFrom: 0,
  rangeTo: 0,
  periodFrom: periodFrom || "",
  periodTo: periodTo || "",
});
